var _path, _circle, _circle2, _circle3, _path2, _path3, _circle4, _path4, _path5, _path6, _path7, _path8, _circle5, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsultationsSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 813.036,
    height: 658.85,
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e4e4e4",
    d: "M808.21 35.47H4.826a4.505 4.505 0 0 1-4.5-4.5V4.5a4.505 4.505 0 0 1 4.5-4.5h803.382a4.505 4.505 0 0 1 4.5 4.5v26.47a4.505 4.505 0 0 1-4.5 4.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.442,
    cy: 16.444,
    r: 6.389,
    fill: "#fff",
    "data-name": "Ellipse 90"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.692,
    cy: 16.444,
    r: 6.389,
    fill: "#fff",
    "data-name": "Ellipse 91"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.943,
    cy: 16.444,
    r: 6.389,
    fill: "#fff",
    "data-name": "Ellipse 92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M802.126 658.85H444.81a10.922 10.922 0 0 1-10.91-10.91V395.358a10.922 10.922 0 0 1 10.91-10.91h357.315a10.922 10.922 0 0 1 10.91 10.91V647.94a10.922 10.922 0 0 1-10.91 10.91z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M787.25 399.322H459.691a10.929 10.929 0 0 0-10.915 10.915V633.06a10.929 10.929 0 0 0 10.915 10.915h327.56a10.922 10.922 0 0 0 10.906-10.915V410.237a10.922 10.922 0 0 0-10.907-10.915z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 803.932,
    cy: 615.983,
    r: 43.987,
    fill: "#9e616a",
    transform: "rotate(-77.07 631.494 677.162)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#007aff",
    d: "M736.957 602.555a43.187 43.187 0 0 0-30.177-32.521l-.032-.018a18.835 18.835 0 0 0-4.511-1.547l-52.862-10.817-10.591-11.364-45.066 2.877-4.704 13.072-51.766 23.007.858-.602a54.62 54.62 0 0 0-6.458 3.095l-.262.116a16.762 16.762 0 0 0-4.115 2.625c-13.164 9.136-21.862 23.802-22.184 40.154l-1.366 13.343h242.027z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M658.588 471.831c-3.6-11.247-14.136-20.745-25.943-20.443.92-2.806-.651-5.952-3.002-7.738-2.352-1.785-5.325-2.5-8.216-3.102-5.975-1.245-12.202-2.196-18.143-.793-5.94 1.403-11.57 5.665-12.907 11.62-5.41-5.071-15.415-3.668-19.222 2.696-1.959 3.275-2.237 7.675-.12 10.85 2.104 3.155 6.089 4.575 9.876 4.754 3.788.179 7.539-.671 11.31-1.067 9.007-.946 18.522.87 25.804 6.255 7.281 5.386 11.935 14.62 10.64 23.585 2.91-1.86 7.104-.568 9.137 2.225s2.194 6.609 1.25 9.932c-.945 3.322-2.862 6.271-4.752 9.163l-10.441 15.973 1.425.948c5.25 2.214 10.93-1.925 14.753-6.15a85.2 85.2 0 0 0 15.356-24.165c4.566-10.892 6.797-23.295 3.195-34.543z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M468.838 463.26H13.89A13.907 13.907 0 0 1 0 449.37V127.772a13.907 13.907 0 0 1 13.89-13.891h454.948a13.907 13.907 0 0 1 13.89 13.89V449.37a13.907 13.907 0 0 1-13.89 13.891z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M449.897 132.82H32.837a13.915 13.915 0 0 0-13.897 13.897v283.707a13.915 13.915 0 0 0 13.897 13.897h417.06a13.906 13.906 0 0 0 13.887-13.897V146.717a13.906 13.906 0 0 0-13.887-13.897z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m301.375 265.962-.769 1.386c6.847-16.873.62-37.666-11.593-50.39-12.214-12.723-29.193-18.54-45.913-20.847-12.411-1.713-25.294-1.664-37.096 2.883-17.09 6.583-30.147 21.824-41.049 37.678-4.986 7.252-9.89 15.52-9.392 24.583.46 8.411 5.454 15.549 9.542 22.685 4.09 7.136 7.504 15.99 4.57 23.779-1.75 4.641-5.445 7.984-8.444 11.78-2.999 3.797-5.466 8.93-4.017 13.693 1.172 3.854 4.697 6.389 8.323 7.234 3.625.844 7.386.292 11.057-.262l95.3-14.399a40.615 40.615 0 0 0 29.481-59.803z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.49,
    cy: 278.507,
    r: 46.594,
    fill: "#ffb9b9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#007aff",
    d: "M346.707 383.985a40.036 40.036 0 0 0-33.988-23.34l-12.986-.786.031.136-33.01-19.858c.811.93-53.696 2.877-53.696 2.877l-20.224 17.448-8.481.513a40.035 40.035 0 0 0-33.988 23.34l-27.543 60.336h54.897l1.273-5.48q2.078 2.531 4.03 5.15H374.25z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M274.685 235.262c-1.203-6.363-7.692-9.273-13.252-10.683a127.658 127.658 0 0 0-49.386-2.712c-12.014 1.714-24.314 5.492-33.032 14.87-6.799 7.314-10.913 17.792-11.233 28.61-.186 6.305.941 12.866 4.078 18.176 3.137 5.31 8.485 9.161 14.004 9.026l.56 1.944c23.393-3.26 45.123-17.815 58.809-39.392a50.467 50.467 0 0 1-14.744 23.819 91.867 91.867 0 0 0 39.657-30.563c2.767-3.673 5.454-8.254 4.54-13.095z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M784.45 12.047h-27.925a2.069 2.069 0 1 1 0-4.137h27.924a2.069 2.069 0 0 1 0 4.137zm0 7.757h-27.925a2.069 2.069 0 1 1 0-4.137h27.924a2.069 2.069 0 0 1 0 4.137zm0 7.756h-27.925a2.069 2.069 0 1 1 0-4.137h27.924a2.069 2.069 0 0 1 0 4.137z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultationsSvg);
export default __webpack_public_path__ + "static/media/consultations-svg.d9116799ff923b35b8094ec40b099c9b.svg";
export { ForwardRef as ReactComponent };